<template>
  <div class="container-fluid product-detail">
    <div
      class="row align-items-center justify-content-center"
      style="min-height: 65vh"
      v-if="loading"
    >
      <div class="col-1">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div v-else-if="loadError" class="product-load-error" role="alert">
      <b-icon icon="exclamation-circle" aria-hidden="true" />
      <h2>No pudimos cargar este producto</h2>
      <p>Puede que ya no esté disponible. Inténtalo de nuevo o elige otro producto.</p>
      <button type="button" class="btn btn-outline-secondary" @click="load">Reintentar</button>
    </div>
    <div class="row product-hero" v-else>
      <div class="col-12 mb-2 d-none">
        <h3 class="click btn-link text-muted" @click="back()">
          &#8592; VOLVER
        </h3>
      </div>

      <div class="col-12">
        <h2 class="text-uppercase font-weight-bold d-none">
          {{ product.name }}
        </h2>
      </div>

      <div class="col-12 col-md-5 product-hero__media" v-if="product.image">
        <div class="text-center border product-image">
          <img
            :src="getImage(product.image)"
            class="img-fluid"
            :alt="product.name"
            loading="eager"
            style="width: 100%"
          />
        </div>
      </div>

      <div class="col py-0 product-hero__details">
        <small class="text-muted product-code" v-if="product.code">REF: {{ product.code }}</small>
        <h2 class="text-uppercase font-weight-bold d-none1 product-title">
          {{ product.name }}
        </h2>

        <div
          class="badge badge-danger d-block w-100 py-2 product-description product-price"
        >
          <small class="product-price__label">PRECIO</small>
          <small
            class="d-block text-secondary promo-old-price"
            v-if="getDiscount > 0"
          >
            <s>${{ formatNumber(total) }}</s>
          </small>
          <strong class="d-block">
            ${{ formatNumber(total - getDiscount) }}
          </strong>
        </div>
        <div
          class="alert alert-primary product-offer"
          v-if="getPromos"
        >
          <small class="product-offer__eyebrow">OFERTA DISPONIBLE</small>
          <strong class="product-offer__text">{{ getPromos }}</strong>
        </div>
        <div
          class="alert alert-primary text-center"
          v-if="getAvaiable"
        >
          <strong>Disponible: {{ getAvaiable }}</strong>
        </div>
        <div class="product-description-copy">
        <small class="d-block text-muted text-uppercase">Descripción</small>
        <div class="my-1 bg-white1">
          <span
            class="d-block px-0 product-description-copy__text"
            >{{ product.description || "Sin descripción disponible." }}</span
          >
        </div>
        </div>
      </div>
      <div class="col-12 product-detail__configuration">
        <div class="my-4">
          <div
            class="row border-bottom py-2 px-0 option-block"
            v-for="(op, i) in options"
            :key="i"
            :ref="`option-block-${i}`"
            :class="{
              'option-block--active': useAccordion && isOptionOpen(i),
              'option-block--done': useAccordion && !isOptionOpen(i) && isOptionComplete(op),
            }"
          >
            <div
              class="col-12 font-weight-bold"
              :class="{ click: useAccordion }"
              @click="useAccordion ? openOption(i) : null"
            >
              <div class="d-flex align-items-start justify-content-between">
                <div class="pr-3">
                  <span class="text-uppercase mr-2">{{ op.displayLabel || op.label || op.name }}</span>
                  <div class="w-100"></div>
                  <div
                    class="badge badge-danger mb-1"
                    v-if="op.min > 0 || !op.multiple"
                  >
                    <small>OBLIGATORIO</small>
                  </div>
                  <div class="badge badge-info" v-else>
                    <small>OPCIONAL</small>
                  </div>
                </div>
                <div v-if="useAccordion" class="text-right option-status">
                  <small
                    class="d-block font-weight-bold"
                    :class="isOptionComplete(op) ? 'text-success' : 'text-muted'"
                  >
                    {{ isOptionComplete(op) ? "Listo" : "Pendiente" }}
                  </small>
                  <small class="text-muted d-block">{{ i + 1 }}/{{ options.length }}</small>
                </div>
              </div>
              <div class="w-100"></div>
              <small class="text-uppercase py-1 d-block option-summary"
                >Seleccionaste:
                <strong>{{ getSelected(op.selected) }}</strong></small
              >
              <div class="w-100"></div>
              <small class="text-muted" v-if="op.multiple"
                >Puedes elegir entre {{ op.min }} - {{ op.max }} opciones</small
              >
              <small
                class="text-primary d-block mt-1"
                v-if="useAccordion && !isOptionOpen(i)"
              >
                Toca para {{ isOptionComplete(op) ? "editar" : "continuar selección" }}
              </small>
            </div>
            <div class="col-12 pt-2" v-show="!useAccordion || isOptionOpen(i)">
              <div class="alert alert-light border py-2 px-3 mb-2" v-if="useAccordion">
                <small class="text-muted d-block">{{ getOptionGuide(op) }}</small>
              </div>
            <div class="col-12 px-0" v-if="op.type == 'select'">
              <div class="row no-gutters px-0">
                <div
                  class="px-1 py-1"
                  :class="getOptionImage(val) ? 'col-12 col-sm-6 col-md-4' : 'col-6 col-md-4'"
                  v-for="(val, i) in op.options"
                  :key="val._id"
                >
                  <b-dropdown
                    v-if="val.optionGroup"
                    :id="`dropdown-${i}`"
                    :text="`${val.name} · ${getSelectedText(op.selected, op, val)}`"
                    :menu-class="{
                      'text-uppercase': 1,
                      'product-option-group__menu': 1,
                    }"
                    :toggle-class="{
                      'text-uppercase h-100 product-option-group__button': 1,
                      'product-option-group__button--selected': isOptionGroupSelected(op, val),
                    }"
                    size="sm"
                    block
                    class="h-100 text-uppercase product-option-group"
                    :variant="isOptionGroupSelected(op, val) ? 'success' : 'outline-secondary'"
                  >
                    <template #button-content>
                      <span class="product-option-group__toggle">
                        <img
                          v-if="getOptionImage(val)"
                          :src="getOptionImage(val)"
                          :alt="val.name"
                          loading="lazy"
                        />
                        <span class="product-option-group__copy">
                          <span class="product-option-group__label">{{ val.name }}</span>
                          <small class="product-option-group__selection">
                            {{ getSelectedText(op.selected, op, val) }}
                          </small>
                        </span>
                      </span>
                    </template>
                    <b-dropdown-item
                      :key="i"
                      class="h-100"
                      :class="{
                        'text-danger': !s._id.enabled,
                        'product-option-group__item--selected': isOptionSelected(op, s._id),
                      }"
                      v-for="(s, i) in val.optionGroup.options"
                      @click="setOption(op, s._id, val._id)"
                      :disabled="!s._id.enabled"
                    >
                      <span class="product-option-group__item">
                        <img
                          v-if="getOptionImage(s._id)"
                          :src="getOptionImage(s._id)"
                          :alt="s._id.name"
                          loading="lazy"
                        />
                        <span>{{ s._id.name }}
                          <small v-if="s._id.value">+${{ formatNumber(s._id.value) }}</small>
                        </span>
                      </span>
                      <div class="w-100"></div>
                      <small
                        v-if="!s._id.enabled"
                        class="text-danger text-uppercase"
                        >(No disponible)</small
                      >
                    </b-dropdown-item>
                  </b-dropdown>
                  <button
                    v-else
                    @click="setOption(op, val)"
                    :aria-pressed="op.selected == val || isIn(op, val)"
                    :class="{
                      'btn-secondary font-weight-bold':
                        op.selected == val || isIn(op, val),
                      'btn-outline-secondary ':
                        op.selected != val && !isIn(op, val),
                      'product-option-choice--selected':
                        op.selected == val || isIn(op, val),
                    }"
                    class="btn btn-block h-100 product-option-choice"
                    :disabled="
                      !val.enabled ||
                      (!isIn(op, val) &&
                        op.max == op.selected.length &&
                        op.selected.length != 0)
                    "
                  >
                    <img
                      v-if="getOptionImage(val)"
                      :src="getOptionImage(val)"
                      :alt="val.name"
                      class="product-option-choice__image"
                      loading="lazy"
                    />
                    <span class="product-option-choice__copy">
                      <strong>{{ val.name }}</strong>
                      <small v-if="val.value">+${{ formatNumber(val.value) }}</small>
                      <small v-if="!val.enabled" class="product-option-choice__unavailable">No disponible</small>
                    </span>
                    <span class="product-option-choice__check" aria-hidden="true">✓</span>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-12 px-0" v-if="op.type == 'number'">
              <div class="d-flex flex-wrap align-items-center mb-2 number-shortcuts">
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm mr-2 mb-2"
                  @click="setNumberOptionValue(op, op.min)"
                >
                  Min {{ op.min }}
                </button>
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm mr-2 mb-2"
                  @click="decrementNumberOption(op)"
                  :disabled="Number(op.selected) <= Number(op.min)"
                >
                  -1
                </button>
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm mr-2 mb-2"
                  @click="incrementNumberOption(op)"
                  :disabled="Number(op.selected) >= Number(op.max)"
                >
                  +1
                </button>
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm mb-2"
                  @click="setNumberOptionValue(op, op.max)"
                >
                  Max {{ op.max }}
                </button>
              </div>
              <input
                type="number"
                class="form-control"
                :min="op.min"
                :max="op.max"
                @focus="$event.target.select()"
                v-model.number="op.selected"
                :class="{
                  'is-valid': op.min <= op.selected || op.max >= op.selected,
                  'is-invalid': op.max < op.selected || op.min > op.selected,
                }"
              />
              <span class="text-muted">
                Numero entre {{ op.min }} y {{ op.max }}
              </span>
            </div>
              <div
                class="d-flex justify-content-end pt-3"
                v-if="useAccordion && canContinueOption(op)"
              >
                <button
                  class="btn btn-sm btn-success px-3"
                  @click="continueFromOption(i)"
                >
                  {{ i === options.length - 1 ? "Finalizar opciones" : "Continuar" }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="py-3"
          id="product-notes"
          v-if="info.settings && info.settings.style == 'delivery'"
        >
          <span class="font-weight-bold">Notas adicionales (opcional)</span>
          <textarea
            class="form-control"
            v-model="details"
            cols="10"
            rows="3"
            placeholder="Opcional"
          ></textarea>
        </div>
        <div class="w-100 my-2"></div>
        <div class="product-purchase">
          <div class="row no-gutters align-items-end px-1">
            <div class="col col-md ml-auto">
              <small>CANTIDAD</small>
              <b-form-spinbutton
                v-model="qty"
                min="1"
                step="1"
                size="lg"
                class="w-100 product-quantity"
                :max="product.stock ? product.qty : 20"
              ></b-form-spinbutton>
            </div>
            <div class="w-100 py-2"></div>
            <div class="col-12 col-md" v-if="product.enabled">
              <button
                class="btn btn-block py-3 h-100 btn-primary font-weight-bold product-add-button"
                @click="addToCart()"
                :disabled="product.stock && product.qty <= 0"
              >
                <span v-if="product.stock && product.qty <= 0"
                  >PRODUCTO SIN STOCK</span
                >
                <span v-else>{{ isEditingCartProduct ? "GUARDAR CAMBIOS" : "AGREGAR" }}</span>
              </button>
            </div>
            <div class="col-12 col-md" v-if="!product.enabled">
              <button
                class="btn btn-block py-3 h-100 btn-primary font-weight-bold product-add-button"
                disabled
              >
                PRODUCTO NO DISPONIBLE
              </button>
            </div>
          </div>

          <div
            v-for="(item, i) in pagecomponents"
            class="content c0"
            :key="`item-${i}`"
          >
            <components :item="item" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.product-load-error {
  display: flex;
  min-height: 320px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 32px;
  color: #66788b;
  text-align: center;
}
.product-load-error > svg { color: #d3444a; font-size: 2rem; }
.product-load-error h2 { margin: 0; color: #233547; font-size: 1.35rem; }
.product-load-error p { margin: 0 0 8px; }
.product-detail {
  --product-accent: #2f6346;
  --product-ink: #233a2b;
  padding: 0;
  color: var(--product-ink);
}

.product-hero__media {
  margin-bottom: 18px;
}

.product-image {
  display: grid;
  place-items: center;
  overflow: hidden;
  aspect-ratio: 1 / 1;
  border-color: #e5e9e1 !important;
  border-radius: 16px;
  background: #f7f8f5;
}

.product-image img {
  width: 100%;
  height: 100%;
  max-height: 380px;
  object-fit: var(--product-image-fit, contain);
}

.product-hero__details {
  padding-left: 24px;
}

.product-code {
  display: block;
  margin: 3px 0 8px;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.13em;
}

.product-detail .product-title {
  margin-bottom: 18px;
  color: var(--product-ink);
  font-family: Georgia, 'Times New Roman', serif;
  font-size: clamp(1.5rem, 3vw, 2.15rem);
  line-height: 1.15;
}

.product-detail .product-price {
  padding: 14px 18px !important;
  border: 1px solid #dcead9;
  border-radius: 12px;
  background: #f0f7ed;
  color: var(--product-accent);
  text-align: left;
  white-space: normal;
}

.product-price__label {
  display: block;
  margin-bottom: 5px;
  color: #647969;
  font-size: 0.66rem;
  font-weight: 800;
  letter-spacing: 0.15em;
}

.product-detail .product-price strong {
  font-size: 1.55rem;
  line-height: 1.15;
}

.product-detail .product-offer {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 12px;
  padding: 13px 16px;
  border: 1px solid #efdcb2;
  border-radius: 12px;
  background: #fff8e9;
  color: #624923;
  text-align: left;
}

.product-offer__eyebrow {
  font-size: 0.67rem;
  font-weight: 800;
  letter-spacing: 0.14em;
}

.product-offer__text {
  font-size: 0.98rem;
  line-height: 1.4;
  white-space: pre-line;
}

.product-description-copy {
  margin-top: 22px;
}

.product-description-copy > small {
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.13em;
}

.product-description-copy__text {
  color: #44594a;
  font-size: 0.94rem;
  line-height: 1.55;
  white-space: break-spaces;
}

.product-detail__configuration {
  margin-top: 6px;
}

.product-purchase {
  padding: 20px;
  border: 1px solid #e4ebe1;
  border-radius: 14px;
  background: #f8faf6;
}

.product-purchase small {
  font-weight: 700;
  letter-spacing: 0.05em;
}

.product-quantity {
  border-color: #d4dfd1;
  border-radius: 10px;
  background: #fff;
}

.product-detail .product-add-button {
  border-color: var(--product-accent);
  border-radius: 10px;
  background: var(--product-accent);
  font-size: 0.88rem;
  letter-spacing: 0.06em;
}

.product-detail .product-add-button:not(:disabled):hover,
.product-detail .product-add-button:not(:disabled):focus-visible {
  border-color: #214a33;
  background: #214a33;
}

.promo-old-price {
  color: #728777 !important;
  font-size: 0.8rem;
  line-height: 1.1;
}

.option-block {
  margin: 0 0 12px;
  padding: 16px !important;
  border: 1px solid #e2e9df !important;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 6px 22px rgba(28, 56, 37, 0.04);
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.option-block--active {
  background: linear-gradient(180deg, #f8fbf5 0%, #edf6e9 100%);
  border: 1px solid #a7cfad !important;
  box-shadow: 0 0 0 3px rgba(76, 132, 83, 0.12);
}

.option-block--done {
  background: #f8fafc;
}

.option-status {
  min-width: 72px;
}

.option-summary {
  color: #334155;
}

.option-block .badge-info {
  background: #e5f2e9;
  color: #276143;
}

.product-option-choice {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 58px;
  padding: 8px 10px;
  border: 1px solid #d8e3d8;
  border-radius: 10px;
  background: #fff;
  color: #2a4432;
  text-align: left;
  white-space: normal;
  box-shadow: 0 2px 8px rgba(31, 61, 37, 0.04);
  transition: border-color 160ms ease, background-color 160ms ease, box-shadow 160ms ease;
}

.product-option-choice:hover:not(:disabled),
.product-option-choice:focus-visible:not(:disabled) {
  border-color: #70a77b;
  background: #f3f8f2;
  color: #213e2a;
  box-shadow: 0 4px 12px rgba(31, 61, 37, 0.11);
}

.product-option-choice--selected,
.product-option-choice--selected:hover:not(:disabled) {
  border-color: #356849;
  background: #356849;
  color: #fff;
}

.product-option-choice:disabled {
  border-color: #e3e7e1;
  background: #f5f6f3;
  color: #748177;
  opacity: 0.75;
}

.product-option-choice__image,
.product-option-group__toggle img,
.product-option-group__item img {
  flex: 0 0 50px;
  width: 50px;
  height: 50px;
  border-radius: 8px;
  object-fit: cover;
  background: #edf1e9;
}

.product-option-choice__copy {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  gap: 3px;
}

.product-option-choice__copy strong {
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1.25;
}

.product-option-choice__copy small {
  color: #98704d;
  font-size: 0.7rem;
  font-weight: 700;
}

.product-option-choice--selected .product-option-choice__copy small {
  color: #e4f1e5;
}

.product-option-choice__copy .product-option-choice__unavailable {
  color: #b84c42;
}

.product-option-choice__check {
  display: none;
  flex: 0 0 20px;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  font-size: 0.72rem;
}

.product-option-choice--selected .product-option-choice__check {
  display: inline-flex;
}

.product-option-group__toggle,
.product-option-group__item {
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: left;
  white-space: normal;
}

.product-option-group__toggle {
  min-width: 0;
}

.product-option-group__copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.product-option-group__label {
  font-size: 0.78rem;
  font-weight: 750;
}

.product-option-group__selection {
  color: #64748b;
  font-size: 0.68rem;
  font-weight: 500;
  line-height: 1.2;
  text-transform: capitalize;
}

.product-option-group__button {
  min-height: 52px;
  padding: 0.55rem 0.65rem;
  border-radius: 11px;
  text-align: left;
  white-space: normal;
}

.product-option-group__button--selected .product-option-group__selection {
  color: rgba(255, 255, 255, 0.86);
}

.product-option-group__item--selected {
  background: #edf7f0;
  color: #24573b;
  font-weight: 700;
}

.product-option-group__item small {
  display: block;
  color: #98704d;
}

.number-shortcuts .btn {
  min-width: 72px;
  font-weight: 600;
}

@media (max-width: 767.98px) {
  .product-hero {
    margin-left: 0;
    margin-right: 0;
  }

  .product-hero__media {
    padding-left: 0;
    padding-right: 0;
  }

  .product-image {
    width: 100%;
    aspect-ratio: 4 / 3;
    --product-image-fit: cover;
  }

  .product-image img {
    max-height: none;
  }

  .product-hero__details {
    padding-left: 0;
    padding-right: 0;
  }

  .product-purchase {
    padding: 15px;
  }

  .option-block {
    padding: 12px !important;
  }

  .product-option-choice {
    min-height: 62px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .product-option-choice,
  .option-block {
    transition: none;
  }
}
</style>

<style>
.product-option-group {
  display: block;
  width: 100%;
  height: 100%;
}

.product-option-group .dropdown-toggle.product-option-group__button {
  display: flex;
  width: 100%;
  min-height: 52px;
  align-items: center;
  justify-content: space-between;
  padding: 0.55rem 0.7rem;
  border: 1px solid #cbd5e1;
  border-radius: 11px;
  background: #fff;
  color: #2a4432;
  text-align: left;
  white-space: normal;
  box-shadow: 0 2px 8px rgba(31, 61, 37, 0.04);
}

.product-option-group .dropdown-toggle.product-option-group__button:hover,
.product-option-group .dropdown-toggle.product-option-group__button:focus {
  border-color: #70a77b;
  background: #f3f8f2;
  color: #213e2a;
  box-shadow: 0 4px 12px rgba(31, 61, 37, 0.11);
}

.product-option-group
  .dropdown-toggle.product-option-group__button--selected,
.product-option-group
  .dropdown-toggle.product-option-group__button--selected:hover,
.product-option-group
  .dropdown-toggle.product-option-group__button--selected:focus {
  border-color: #356849;
  background: #356849;
  color: #fff;
}

.product-option-group .product-option-group__toggle {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
  text-align: left;
  white-space: normal;
}

.product-option-group .product-option-group__copy {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.product-option-group .product-option-group__label {
  font-size: 0.78rem;
  font-weight: 750;
}

.product-option-group .product-option-group__selection {
  color: #64748b;
  font-size: 0.7rem;
  font-weight: 500;
  line-height: 1.2;
  text-transform: capitalize;
}

.product-option-group
  .product-option-group__button--selected
  .product-option-group__selection {
  color: rgba(255, 255, 255, 0.86);
}

.product-option-group .product-option-group__menu {
  min-width: 100%;
  max-height: min(50vh, 320px);
  overflow-y: auto;
  padding: 0.35rem;
  border: 1px solid #dce6dc;
  border-radius: 12px;
  box-shadow: 0 14px 32px rgba(24, 43, 30, 0.18);
}

.product-option-group .product-option-group__menu .dropdown-item {
  padding: 0.65rem 0.75rem;
  border-radius: 8px;
  white-space: normal;
}

.product-option-group
  .product-option-group__menu
  .product-option-group__item--selected {
  background: #edf7f0;
  color: #24573b;
  font-weight: 700;
}

.swal-modal.product-added-alert {
  width: calc(100% - 32px);
  max-width: 440px;
  padding: 30px 30px 22px;
  border: 1px solid #e3ebe4;
  border-radius: 22px;
  background: #fff;
  box-shadow: 0 24px 70px rgba(15, 35, 24, 0.24);
  font-family: inherit;
}

.product-added-alert .swal-icon--success {
  margin: 0 auto 18px;
  transform: scale(0.9);
}

.product-added-alert .swal-title {
  margin: 0;
  padding: 0;
  color: #20382a;
  font-size: clamp(1.45rem, 5vw, 1.8rem);
  font-weight: 800;
  letter-spacing: -0.025em;
}

.product-added-alert .swal-text {
  max-width: 330px;
  margin: 0.7rem auto 0;
  color: #64748b;
  font-size: 0.98rem;
  line-height: 1.5;
  text-align: center;
}

.product-added-alert .swal-footer {
  display: flex;
  justify-content: center;
  gap: 0.65rem;
  margin-top: 24px;
  padding: 0;
}

.product-added-alert .swal-button-container {
  margin: 0;
}

.product-added-alert .swal-button {
  min-height: 44px;
  padding: 0.7rem 1.2rem;
  border-radius: 11px;
  font-size: 0.9rem;
  font-weight: 750;
  transition: background-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.product-added-alert .product-added-alert__cart {
  border: 1px solid #276342;
  background: #276342;
  color: #fff;
}

.product-added-alert .product-added-alert__cart:hover {
  background: #1e5235;
  box-shadow: 0 8px 18px rgba(39, 99, 66, 0.2);
  transform: translateY(-1px);
}

.product-added-alert .product-added-alert__accept {
  border: 1px solid #d5e2d8;
  background: #f5f8f5;
  color: #34513e;
}

.product-added-alert .product-added-alert__accept:hover {
  background: #eaf2eb;
}

.product-added-alert .swal-button:focus {
  box-shadow: 0 0 0 3px rgba(39, 99, 66, 0.2);
}

@media (prefers-reduced-motion: reduce) {
  .product-option-group .dropdown-toggle,
  .product-added-alert .swal-button {
    transition: none;
  }
}

@media (max-width: 480px) {
  .swal-modal.product-added-alert {
    padding: 26px 20px 20px;
  }

  .product-added-alert .swal-footer {
    flex-direction: column-reverse;
  }

  .product-added-alert .swal-button-container,
  .product-added-alert .swal-button {
    width: 100%;
  }
}
</style>

<script>
//import components from "../components/components";
const components = () => import("../components/components");

export default {
  components: {
    components,
  },
  props: {
    id: { type: [String, Number], default: null },
    textColor: { type: String, default: "" },
    editing: { type: Boolean, default: false },
    initialProduct: { type: Object, default: null },
  },
  data() {
    return {
      loading: true,
      loadError: false,
      productRequestId: 0,
      product: {
        ref: {},
      },
      options: [],
      activeOptionIndex: 0,
      details: "",
      qty: 1,
      notes: "",
      hydratingDraft: false,
    };
  },
  computed: {
    isEditingCartProduct() {
      if (this.editing) return true;
      const editingCartProduct = this.$store.state.editingCartProduct;
      return !!(
        editingCartProduct &&
        `${editingCartProduct.productId}` === `${this.id}`
      );
    },
    useAccordion() {
      return this.options.length > 5;
    },
    getAvaiable() {
      const values = this.product.available_on

      if(!values) return false
      let rs = "";

      if (values.length == 1) {
        const [value] = values;
        if (value == "pickup") rs = "Solo retiro";
        if (value == "delivery") rs = "Solo Delivery";
        if (value == "shipping") rs = "Solo Envio";
      } 
      else {
        //rs += "Disponible: "
        values.forEach((value) => {
          
          if (value == "pickup") rs += "Retiro ";
          if (value == "delivery") rs += "- Domicilio ";
          if (value == "shipping") rs += "- Envio ";
        });
      }

      return rs;
    },

    pagecomponents() {
      return this.$store.state.components;
    },
    getPromos() {
      const promos = Array.isArray(this.product.promos)
        ? this.product.promos.filter((promo) => promo && promo.enabled)
        : [];

      let rs = "";


      promos.forEach((promo) => {
        const discountText = promo.in == "%"
          ? `${promo.discount}% de descuento`
          : `$${this.formatNumber(promo.discount)} de descuento`;
        if (promo.to == "product") {
          const quantity = Number(promo.value);
          rs += promo.when == "qty" && quantity > 1
            ? `${discountText} desde ${quantity} unidades\n`
            : `${discountText}\n`;
          return;
        }

        if (promo.to == "total" && promo.when == "qty") {
          const quantity = Number(promo.value);
          rs += quantity > 1
            ? `${discountText} desde ${quantity} unidades\n`
            : `${discountText}\n`;
          return;
        }

        if (promo.to == "total" && promo.when == "total") {
          rs += Number(promo.value) > 0
            ? `${discountText} en compras desde $${this.formatNumber(promo.value)}\n`
            : `${discountText}\n`;
          return;
        }

        if (promo.to == "option") {
          if (promo.in == "%" && Number(promo.discount) === 100) {
            rs += promo.value
              ? `Extra gratis desde $${this.formatNumber(promo.value)}\n`
              : "Extra gratis\n";
            return;
          }

          rs +=
            promo.when == "minopcion" && promo.value
              ? `${promo.in == "%" ? promo.discount + "%" : "-$" + this.formatNumber(promo.discount)} en extras desde $${this.formatNumber(promo.value)}\n`
              : `${promo.in == "%" ? promo.discount + "%" : "-$" + this.formatNumber(promo.discount)} en opciones extra\n`;
        }
      });

      if (rs === "undefined" || !rs.trim()) return false;
      return rs.trim();
    },
    settings() {
      return this.info && this.info.settings ? this.info.settings : {};
    },
    info() {
      return this.$store.state.info;
    },
    textClass() {
      return this.textColor || "text-white";
    },
    getExtras() {
      let values = new Set();

      this.options.forEach((o) => {
        if (o.selected == "" || o.selected == null) {
          //
        } else {
          if (o.selected && o.selected.value) {
            values.add(o.selected.value);
          }
          if (o.multiple) {
            o.selected.forEach((_o) => {
              if (_o && _o.value) {
                values.add(_o.value);
              }
            });
          }
        }
      });

      return values;
    },
    getDiscount() {
      let discount = 0;
      let qty = this.qty;
      if (this.product.promos && this.product.promos.length > 0) {
        let enabledPromos = this.product.promos.filter((p) => p.enabled);
        //let product = this.product;
        // apply discount for each promo enabled
        enabledPromos.forEach((promo) => {
          // descuento cuando es a la cantidad
          if (promo.when == "qty") {
            if (this.checkCondition(qty, promo.is, promo.value)) {
              // el descuento afecta al total
              if (promo.to == "total") {
                if (promo.in == "%") {
                  discount = (this.total * promo.discount) / 100;
                }
                if (promo.in == "$") {
                  discount = promo.discount;
                }
              } else if (promo.to == "product") {
                if (promo.in == "%") {
                  discount = (this.total * promo.discount) / 100;
                }
                if (promo.in == "$") {
                  discount = qty * promo.discount;
                }
              }
            }
          }

          // descuento cuando la total es
          if (promo.when == "total") {
            // ???
          }

          if (promo.when == "minopcion" && [this.getExtras].length > 0) {
            if (promo.to == "option") {
              let filterExtras = [...this.getExtras].filter(
                (e) => e > promo.value
              );

              if (filterExtras.length == 0) {
                return discount;
              } else {
                if (promo.in == "$") {
                  discount = promo.discount;
                }
                if (promo.in == "%") {
                  //discount = (this.total * promo.discount) / 100;
                }
                discount = Math.min(...filterExtras);
              }
            }
          }
        });
      }
      // TODO: verificar el descuento cuando la cantidad sea mayor a 1
      return discount;
    },
    total() {
      let t = 0;

      this.options.forEach((o) => {
        if (o.selected == "" || o.selected == null) {
          //
        } else {
          if (o.selected && o.selected.value) {
            t = t + o.selected.value;
          }
          if (o.multiple) {
            o.selected.forEach((_o) => {
              if (_o && _o.value) {
                t = t + _o.value;
              }
            });
          }
        }
      });

      return (this.product.value + t) * this.qty;
    },
  },
  methods: {
    getOptionImage(value) {
      if (this.settings.showProductOptionImages === false) return null;
      if (!value) return null;
      const image = value.image || (value.linkedProduct && value.linkedProduct.image);
      const path = typeof image === "string" ? image : image && (image.url || image.path);
      if (!path || typeof path !== "string") return null;
      const trimmed = path.trim();
      if (!trimmed) return null;
      if (/^(https?:)?\/\//i.test(trimmed) || /^data:image\//i.test(trimmed)) return trimmed;
      return this.getImage(trimmed.replace(/^\/+/, ""));
    },
    getProductDraft() {
      return this.$store.state.productDrafts[this.id] || null;
    },
    getDraftSelectableValue(op, selectedId) {
      if (!op || !selectedId) return null;
      const direct = (op.options || []).find((value) => `${value._id}` === `${selectedId}`);
      if (direct) return direct;

      for (const value of op.options || []) {
        if (!value.optionGroup || !value.optionGroup.options) continue;
        const nested = value.optionGroup.options.find((entry) => `${entry._id._id}` === `${selectedId}`);
        if (nested) return nested._id;
      }

      return null;
    },
    getDraftSelectableValueByName(op, selectedName) {
      if (!op || !selectedName) return null;
      const normalizedName = `${selectedName}`.trim().toLowerCase();
      const direct = (op.options || []).find(
        (value) => `${value.name || ""}`.trim().toLowerCase() === normalizedName
      );
      if (direct) return direct;

      for (const value of op.options || []) {
        if (!value.optionGroup || !value.optionGroup.options) continue;
        const nested = value.optionGroup.options.find((entry) => {
          const optionValue = entry && entry._id ? entry._id : {};
          return `${optionValue.name || ""}`.trim().toLowerCase() === normalizedName;
        });
        if (nested) return nested._id;
      }

      return null;
    },
    getDraftOptionKey(option = {}) {
      return `${option.label || option.name || ""}`.trim().toLowerCase();
    },
    applyProductDraft() {
      const draft = this.getProductDraft();
      if (!draft) return;

      this.hydratingDraft = true;
      this.qty = Number(draft.qty) || 1;
      this.details = draft.details || "";
      this.activeOptionIndex = Number.isInteger(draft.activeOptionIndex)
        ? draft.activeOptionIndex
        : 0;

      (draft.options || []).forEach((savedOption, savedIndex) => {
        const savedOptionKey = this.getDraftOptionKey(savedOption);
        const currentOption =
          (Number.isInteger(savedOption.draftIndex) &&
          this.options[savedOption.draftIndex]
            ? this.options[savedOption.draftIndex]
            : null) ||
          this.options.find((option) => {
            if (`${option._id}` === `${savedOption._id}`) return true;
            if (savedOption.refId && `${option.refId}` === `${savedOption.refId}`) return true;
            return this.getDraftOptionKey(option) === savedOptionKey;
          }) ||
          this.options[savedIndex];
        if (!currentOption) return;

        currentOption.parent = savedOption.parent || null;

        if (currentOption.type == "number") {
          currentOption.selected = Number(savedOption.selected);
          return;
        }

        if (currentOption.multiple) {
          const selectedValues =
            (savedOption.selectedIds || [])
              .map((selectedId) => this.getDraftSelectableValue(currentOption, selectedId))
              .filter(Boolean);

          currentOption.selected = (
            selectedValues.length > 0
              ? selectedValues
              : (savedOption.selectedNames || [])
                .map((selectedName) => this.getDraftSelectableValueByName(currentOption, selectedName))
                .filter(Boolean)
          );
          return;
        }

        currentOption.selected =
          this.getDraftSelectableValue(currentOption, savedOption.selectedId) ||
          this.getDraftSelectableValueByName(currentOption, savedOption.selectedName) ||
          "";
      });

      this.$nextTick(() => {
        this.hydratingDraft = false;
      });
    },
    persistProductDraft() {
      if (this.hydratingDraft || !this.id) return;

      const draft = {
        qty: this.qty,
        details: this.details,
        activeOptionIndex: this.activeOptionIndex,
        options: this.options.map((option) => ({
          _id: option._id,
          refId: option.refId || option._id,
          draftIndex: this.options.indexOf(option),
          label: option.label || option.name || "",
          name: option.name || option.label || "",
          type: option.type,
          multiple: option.multiple,
          parent: option.parent || null,
          selected:
            option.type == "number"
              ? Number(option.selected)
              : option.multiple
                ? undefined
                : option.selected && option.selected._id
                  ? option.selected._id
                  : option.selected,
          selectedId:
            !option.multiple && option.type != "number" && option.selected && option.selected._id
              ? option.selected._id
              : null,
          selectedIds: option.multiple
            ? (option.selected || []).map((selected) => selected && selected._id).filter(Boolean)
            : [],
          selectedName:
            !option.multiple && option.type != "number"
              ? (option.selected && option.selected.name ? option.selected.name : option.selected || "")
              : "",
          selectedNames: option.multiple
            ? (option.selected || []).map((selected) => selected && selected.name).filter(Boolean)
            : [],
        })),
      };

      this.$store.commit("setProductDraft", {
        productId: this.id,
        draft,
      });
    },
    load() {
      const pid = this.id;
      const requestId = ++this.productRequestId;
      const { webName } = this.$store.state.info;
      this.loading = true;
      this.loadError = false;

      if (this.initialProduct && `${this.initialProduct._id}` === `${pid}`) {
        try {
          this.applyLoadedProduct(this.initialProduct);
        } catch (error) {
          this.loadError = true;
          this.$emit("load-error", error);
        } finally {
          this.loading = false;
        }
        return;
      }

      if (!pid || !webName) {
        this.loadError = true;
        this.loading = false;
        this.$emit("load-error");
        return;
      }

      this.$http
        .get(`${webName}/product/${pid}`)
        .then((res) => {
          if (requestId !== this.productRequestId) return;
          this.applyLoadedProduct(res.data && res.data.data);
        })
        .catch((error) => {
          if (requestId !== this.productRequestId) return;
          this.loadError = true;
          this.$emit("load-error", error);
        })
        .finally(() => {
          if (requestId === this.productRequestId) this.loading = false;
        });
    },
    applyLoadedProduct(data) {
      if (!data || !data._id) throw new Error("Producto no disponible");
      this.product = data;
      this.$emit("loaded", data.name);
      this.$store.commit("setProduct", data);
      document.title = `${(data.name || "Producto").toUpperCase()} `;
      this.options = (Array.isArray(data.newOptions) ? data.newOptions : [])
        .filter((option) => option && option.ref)
        .map((option, optionIndex) => {
          const ref = option.ref;
          const entry = {
            _id: option._id || `${ref._id}-${optionIndex}`,
            refId: ref._id,
            type: ref.type,
            displayLabel: option.custom_label || ref.name || ref.label,
            label: option.custom_label || ref.label || ref.name,
            name: option.custom_label || ref.name,
            options: (Array.isArray(ref.options) ? ref.options : []).map((value) => value._id).filter(Boolean),
            selected: "",
            min: ref.min,
            max: ref.max,
            multiple: ref.multiple,
          };
          if (entry.type == "select" && entry.multiple) entry.selected = [];
          else if (entry.type == "number") entry.selected = ref.min;
          return entry;
        });
      this.activeOptionIndex = 0;
      this.applyProductDraft();
      this.$nextTick(() => {
        this.$emit("update", {
          loaded: true,
          pid: this.id,
          name: data.name || "",
          pageTitle: document.title || `${data.name || ""}`.toUpperCase(),
          path: this.$route ? this.$route.fullPath : window.location.pathname + window.location.search,
        });
      });
    },
    getSelected(selected) {
      if (typeof selected == "number") return selected;
      if (selected == "" || selected == null) return "Nada aun";
      if (Array.isArray(selected)) {
        return selected.map((s) => s.name).join(",");
      } else if (selected.name) return selected.name;
      return selected;
    },
    // getSelectedText(selected, op) {
    getSelectedText(selected, op, group) {
      const values = group && group.optionGroup && group.optionGroup.options;
      if (!Array.isArray(values)) return "Seleccionar alternativa";

      const selectedValues = Array.isArray(selected)
        ? selected
        : selected == null || selected === ""
          ? []
          : [selected];
      const selectedIds = selectedValues.map((value) =>
        `${value && typeof value === "object" ? value._id : value}`
      );
      const names = values
        .map((entry) => entry && entry._id)
        .filter((value) => value && selectedIds.includes(`${value._id}`))
        .map((value) => value.name);

      return names.length ? names.join(", ") : "Seleccionar alternativa";
    },
    isOptionGroupSelected(op, group) {
      if (!op || op.parent == null || !group) return false;
      const parentId = op.parent && typeof op.parent === "object"
        ? op.parent._id
        : op.parent;
      return `${parentId}` === `${group._id}`;
    },
    isOptionSelected(op, value) {
      if (!op || !value) return false;
      const selected = Array.isArray(op.selected)
        ? op.selected
        : op.selected == null || op.selected === ""
          ? []
          : [op.selected];
      return selected.some((item) => {
        const selectedId = item && typeof item === "object" ? item._id : item;
        return `${selectedId}` === `${value._id}`;
      });
    },
    isOptionComplete(op) {
      if (!op) return false;
      if (op.type == "number") {
        return Number(op.selected) >= Number(op.min) && Number(op.selected) <= Number(op.max);
      }
      if (op.multiple) {
        return Array.isArray(op.selected) && op.selected.length >= op.min;
      }
      return !(op.selected === "" || op.selected === null);
    },
    isOptionOpen(index) {
      return this.activeOptionIndex === index;
    },
    openOption(index) {
      this.activeOptionIndex = index;
      this.$nextTick(() => {
        const ref = this.$refs[`option-block-${index}`];
        const element = Array.isArray(ref) ? ref[0] : ref;
        if (element && element.scrollIntoView) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },
    getOptionGuide(op) {
      if (op.type == "number") return `Ingresa un valor entre ${op.min} y ${op.max}.`;
      if (op.multiple) return `Selecciona entre ${op.min} y ${op.max} alternativas.`;
      return "Selecciona una alternativa para continuar.";
    },
    canContinueOption(op) {
      if (!this.useAccordion || !op) return false;
      if (!op.multiple && op.type != "number") return false;
      return this.isOptionComplete(op);
    },
    continueFromOption(index) {
      if (index >= this.options.length - 1) return;
      this.openOption(index + 1);
    },
    setNumberOptionValue(op, value) {
      const min = Number(op.min);
      const max = Number(op.max);
      const nextValue = Math.min(Math.max(Number(value), min), max);
      op.selected = nextValue;
    },
    incrementNumberOption(op) {
      this.setNumberOptionValue(op, Number(op.selected || 0) + 1);
    },
    decrementNumberOption(op) {
      this.setNumberOptionValue(op, Number(op.selected || 0) - 1);
    },
    maybeAdvanceOption(op) {
      if (!this.useAccordion) return;
      const index = this.options.indexOf(op);
      if (index === -1 || !this.isOptionComplete(op)) return;
      if (op.multiple || op.type == "number") return;
      this.continueFromOption(index);
    },
    isIn(op, val) {
      //   name: val.name,
      //   op,
      //   val
      // })
      if (
        Array.isArray(op.selected) &&
        op.selected.find((o) => o._id == val._id)
      )
        return true;

      return false;
    },
    contains() {
      // return true
    },
    setOption(op, val, parent = null) {
      if (op.multiple) {
        if (!Array.isArray(op.selected)) op.selected = [];
        const selectedIndex = op.selected.findIndex(
          (item) => `${item && typeof item === "object" ? item._id : item}` === `${val._id}`
        );
        if (selectedIndex === -1) {
          if (op.selected.length >= op.max) return false;
          op.selected.push(val);
        } else {
          op.selected.splice(selectedIndex, 1);
        }
      } else {
        op.selected = val;
      }
      op.parent = parent;
      this.maybeAdvanceOption(op);
      this.persistProductDraft();
    },
    changeValue() {
      event.preventDefault();
    },
    normalizeOptionValue(value) {
      if (!value) return null;
      return {
        _id: value._id,
        name: value.name,
        value: Number(value.value) || 0,
      };
    },
    buildCartOption(option) {
      if (!option) return null;

      if (option.multiple) {
        const values = Array.isArray(option.selected)
          ? option.selected
            .map((value) => this.normalizeOptionValue(value))
            .filter(Boolean)
          : [];

        return {
          _id: option.refId || option._id,
          label: option.label || option.name,
          name: option.name,
          type: option.type,
          multiple: true,
          min: option.min,
          max: option.max,
          selected: values.map((value) => value.name).join(", "),
          values,
          extra: values.reduce(
            (total, value) => total + (Number(value.value) || 0),
            0
          ),
        };
      }

      if (option.type == "number") {
        return {
          _id: option.refId || option._id,
          label: option.label || option.name,
          name: option.name,
          type: option.type,
          multiple: false,
          selected: Number(option.selected) || 0,
          values: [],
          extra: 0,
        };
      }

      const selected = this.normalizeOptionValue(option.selected);
      return {
        _id: option.refId || option._id,
        label: option.label || option.name,
        name: option.name,
        type: option.type,
        multiple: false,
        selected: selected ? selected.name : "",
        values: [],
        extra: selected ? Number(selected.value) || 0 : 0,
      };
    },
    addToCart() {
      let b = false;
      let t = 0;
      this.options.forEach((o) => {
        if (
          (o.selected == "" || o.selected == null) &&
          !Array.isArray(o.selected)
        ) {
          if (o.type == "number") return false;
          b = true;
        } else {
          if (o.selected && o.selected.value) t = t + o.selected.value;
          if (o.multiple) {
            o.selected.forEach((_o) => {
              if (_o && _o.value) t = t + _o.value;
            });
          }
        }
        if (
          Array.isArray(o.selected) &&
          o.multiple &&
          o.selected.length < o.min
        ) {
          b = true;
        }
      });

      let exist = this.$store.state.products.filter(
        (p) => p._id == this.product._id
      );
      let existQty = exist.reduce((t, c) => t + c.qty, 0);
      if (b) {
        this.$swal({
          icon: "error",
          title: "Debe seleccionar las opciones requeridas",
        });
      } else {
        if (
          this.product.stock &&
          exist &&
          existQty + this.qty > this.product.qty
        ) {
          this.$swal({
            icon: "error",
            title: "No puedes agregar mas existencias al carro.",
          });
          return false;
        }
        // if(exist) return false
        const options = this.options
          .map((option) => this.buildCartOption(option))
          .filter(Boolean);
        const subtotal = (Number(this.product.value) + Number(t)) * Number(this.qty || 1);
        const discount = Number(this.getDiscount) || 0;
        const total = Math.max(subtotal - discount, 0);

        this.$store.commit("clearProductDraft", this.id);
        const editingCartProduct = this.$store.state.editingCartProduct;
        const productPayload = {
          ...this.product,
          product: this.product._id,
          options,
          qty: this.qty,
          extra: t,
          discount,
          details: this.details,
          originalTotal: subtotal,
          total,
          tempid:
            editingCartProduct &&
            editingCartProduct.productId == this.id &&
            editingCartProduct.tempid
              ? editingCartProduct.tempid
              : Date.now(),
        };

        if (
          editingCartProduct &&
          editingCartProduct.productId == this.id &&
          editingCartProduct.tempid
        ) {
          this.$store.commit("replaceProductByTempid", productPayload);
          this.$store.commit("clearEditingCartProduct");
        } else {
          this.$store.commit("addProduct", productPayload);
        }

        this.$gtag.event("add_to_cart", {
          event_category: "products",
          event_label: "User add product",
          value: 1,
        });

        this.$swal({
          icon: "success",
          className: "product-added-alert",
          title: this.isEditingCartProduct ? "Producto actualizado" : "Producto agregado",
          text: `${this.qty} × ${this.product.name} ${
            this.isEditingCartProduct ? "actualizado en tu pedido" : "agregado a tu pedido"
          }`,
          buttons: this.isEditingCartProduct
            ? {
                ok: {
                  text: "Aceptar",
                  value: "ok",
                  className: "product-added-alert__accept",
                },
              }
            : {
                cart: {
                  text: "Ver mi pedido",
                  value: "go_cart",
                  className: "product-added-alert__cart",
                },
                ok: {
                  text: "Aceptar",
                  value: "ok",
                  className: "product-added-alert__accept",
                },
              },
        }).then((val) => {
          if (!this.isEditingCartProduct && val == "go_cart") {
            this.$router.push(this.getLink("pedido"));
          }
          else {
            this.$emit("success");
          }
        });
      }
    },
    back() {
      this.$router.back();
    },
    getValues(values = []) {
      return values.split(",");
    },
  },
  mounted() {
    this.load();
  },
  watch: {
    total() {
      let discount = "";
      if (this.getDiscount)
        discount = `(-$${this.formatNumber(this.getDiscount)})`;

      this.$emit(
        "update",
        `${this.product.name} - $${this.formatNumber(this.total)} ${discount}`
      );
    },
    qty() {
      if (this.qty < 1) {
        this.$swal({
          title: "Error",
          text: "Debe ingresar una cantidad valida (1 o más)",
        });
        this.qty = 1;
      }
      this.persistProductDraft();
    },
    details() {
      this.persistProductDraft();
    },
    activeOptionIndex() {
      this.persistProductDraft();
    },
    options: {
      deep: true,
      handler() {
        this.persistProductDraft();
      },
    },
    id() {
      this.load();
    },
  },
};
</script>
